__webpack_require__.p = "/Asad-Clanic-and-Pharmacy/";